import React, { FC } from 'react';
import { NoOfElementsDesc, NoOfElementsInfo, NoSurveysCont } from './NumberOfSurveys.styles';

interface INumberOfSurveys {
  tableElementsTitle: string;
  surveysCount: number;
  description: string;
}

const NumberOfSurveys: FC<INumberOfSurveys> = ({
  surveysCount,
  tableElementsTitle,
  description,
}) => {
  return (
    <NoSurveysCont data-testid="numberOfSurveys">
      <NoOfElementsInfo>
        {tableElementsTitle} ({surveysCount})
      </NoOfElementsInfo>
      <NoOfElementsDesc>{description}</NoOfElementsDesc>
    </NoSurveysCont>
  );
};

export default NumberOfSurveys;
